export default __webpack_public_path__ + "static/media/fMaltoBuza28.6e8126b6.png";